(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-localization"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-loc-selector')) {
    class FooterLocSelector extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.dropdowns = Array.from(this.querySelectorAll('[data-dropdown]'));
        this.dropdowns.forEach((dropdown) => this.setup(dropdown));

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      setup(dropdown) {
        const button = dropdown.querySelector('.footer-loc__button');
        const list = dropdown.querySelector('.footer-loc__list');
        const input = dropdown.querySelector('[data-input]');
        const options = Array.from(list.querySelectorAll('[role="option"]'));

        const open = () => {
          this.closeAll(dropdown);
          list.hidden = false;
          list.classList.remove('is-end');
          button.setAttribute('aria-expanded', 'true');

          const rect = list.getBoundingClientRect();
          if (rect.right > window.innerWidth - 8) list.classList.add('is-end');

          const selected = options.find((o) => o.getAttribute('aria-selected') === 'true') || options[0];
          selected?.focus();
          selected?.scrollIntoView({ block: 'nearest' });
        };

        const close = (returnFocus = false) => {
          list.hidden = true;
          button.setAttribute('aria-expanded', 'false');
          if (returnFocus) button.focus();
        };

        const choose = (option) => {
          const value = option.dataset.value;
          if (!value || value === input.value) {
            close(true);
            return;
          }
          input.value = value;
          this.form.submit();
        };

        dropdown.close = close;

        button.addEventListener('click', () => {
          list.hidden ? open() : close();
        });

        button.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            open();
          }
        });

        options.forEach((option) => {
          option.addEventListener('click', () => choose(option));
        });

        list.addEventListener('keydown', (event) => {
          const current = options.indexOf(document.activeElement);
          let next = null;

          switch (event.key) {
            case 'ArrowDown':
              next = options[Math.min(current + 1, options.length - 1)];
              break;
            case 'ArrowUp':
              next = options[Math.max(current - 1, 0)];
              break;
            case 'Home':
              next = options[0];
              break;
            case 'End':
              next = options[options.length - 1];
              break;
            case 'Enter':
            case ' ':
              event.preventDefault();
              if (current > -1) choose(options[current]);
              return;
            case 'Escape':
              event.preventDefault();
              close(true);
              return;
            case 'Tab':
              close();
              return;
            default:
              if (event.key.length === 1) {
                const letter = event.key.toLowerCase();
                next = options.find((o) =>
                  o.querySelector('.footer-loc__name').textContent.trim().toLowerCase().startsWith(letter)
                );
              }
          }

          if (next) {
            event.preventDefault();
            next.focus();
          }
        });
      }

      closeAll(except) {
        this.dropdowns.forEach((dropdown) => {
          if (dropdown !== except) dropdown.close?.();
        });
      }
    }

    customElements.define('footer-loc-selector', FooterLocSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
